import type { IntegrationConfig } from "@p0security/shared/integrations/shared";
import type { AutoApprover } from "@p0security/shared/types/workflow/types";
import { compact } from "lodash";
import { useMemo } from "react";

import { useFirestoreDoc } from "../../../../providers/FirestoreProvider.tsx";

export const useInstalledApprovers = (): AutoApprover[] => {
  const pd = useFirestoreDoc<IntegrationConfig>("integrations/pagerduty", {
    live: false,
    tenantAware: true,
  });
  const io = useFirestoreDoc<IntegrationConfig>("integrations/incidentio", {
    live: false,
    tenantAware: true,
  });
  return useMemo(
    () =>
      compact([
        !!pd.doc?.data && pd.doc.data.state === "installed" && "pagerduty",
        !!io.doc?.data && io.doc.data.state === "installed" && "incidentio",
      ]),
    [pd.doc?.data, io.doc?.data]
  );
};
